import { Reducer } from "redux";

import { AlertsAction, AlertsActionTypes, AlertsState } from "./types";

const initialState: AlertsState = {
  count: 0,
  alerts: [],
  unreadAlerts: [],
  isLoading: false,
};

const reducer: Reducer<AlertsState, AlertsAction> = (state = initialState, action) => {
  switch (action.type) {
    case AlertsActionTypes.READ_ALERT_REQUEST:
    case AlertsActionTypes.LIST_FETCH_REQUEST:
      return { ...state, isLoading: true };

    case AlertsActionTypes.READ_ALERT_ERROR:
    case AlertsActionTypes.LIST_FETCH_ERROR:
      return { ...state, isLoading: false };

    case AlertsActionTypes.UNREAD_LIST_FETCH_SUCCESS: {
      const { items } = action.payload;
      return { ...state, unreadAlerts: items };
    }

    case AlertsActionTypes.READ_ALERT_SUCCESS: {
      const { id } = action.payload;
      const unreadAlerts = state.unreadAlerts.filter((item) => item.id !== id);
      return { ...state, unreadAlerts, isLoading: false };
    }

    case AlertsActionTypes.LIST_FETCH_SUCCESS: {
      const { count, results } = action.payload;
      return { ...state, count, isLoading: false, alerts: results };
    }

    default:
      return state;
  }
};

export default reducer;
